import React from 'react';
import { GradientTextAction } from 'src/common';
import { mpEvent, MPEvents } from 'src/utils/mixpanel';
import * as S from './Header.styles';

interface HeaderProps {
  onChange: (value: string) => void;
  showViewGlobal: boolean;
  onViewGlobal: () => void;
}

export const Header: React.FC<HeaderProps> = ({ onChange, showViewGlobal, onViewGlobal }) => {
  return (
    <S.Div>
      <S.StyledSearchIcon />
      <input
        type="search"
        onInput={(e) => {
          onChange(e.currentTarget.value);
          mpEvent(MPEvents.TableSearch, {});
        }}
        placeholder="Search by keyword ..."
      />
      {showViewGlobal && (
        <GradientTextAction nowrap $underline weight={500} px={12} onClick={onViewGlobal}>
          View global
        </GradientTextAction>
      )}
    </S.Div>
  );
};
